import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';

const propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
};

const defaultProps = {
    className: '',
    message: 'Empty'
};

function DashboardListItemEmpty(props) {
    return (
        <li className={`${props.className} listing--noBg projectListing`}>
            <Row className="projectListing__wrapper">
                <div
                    className={`bare-text-button no-button-style col-12 projectListing__col--text-centered nowrap`}
                >
                    <em className="font-style-italic">
                        {props.message}
                    </em>
                </div>
            </Row>
        </li>
    );
}

DashboardListItemEmpty.propTypes = propTypes;
DashboardListItemEmpty.defaultProps = defaultProps;

export default DashboardListItemEmpty;
